export default __webpack_public_path__ + "static/media/Outlined.fb5a0557.png";